var React = require('react');

function BackwardCarrotIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.56232 5.69288L5.51367 9.64423L4.62568 10.5322L0.230329 6.13688C-0.0148836 5.89166 -0.0148836 5.4941 0.230329 5.24888L4.62568 0.853535L5.51367 1.74153L1.56232 5.69288Z","fill":"#D71C2E"}));
}

BackwardCarrotIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 6 11","fill":"none"};

module.exports = BackwardCarrotIcon;

BackwardCarrotIcon.default = BackwardCarrotIcon;
